import type { LayoutRuntime } from "../../../../shared/layouts/registry";

export const oddsDefaultLayout: LayoutRuntime = {
  feature: "odds",
  layout: "default",
  rootClass: "gwd-livescore-layout--default",
};
